import { Component, OnInit } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import {SETTINGS} from "../../core/configs/common.settings";

@Component({
  selector: 'app-footer',
  templateUrl: './app.footer.component.html',
})
export class AppFooterComponent implements OnInit {
  currentYear: any = '';
  version = SETTINGS.VERSION;
  constructor(public layoutService: LayoutService) {}
  ngOnInit() {
    this.currentYear = new Date().getFullYear();
  }
}
